import axios from "axios";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();
const token = localStorage.getItem("accessToken");
export async function getGameSlots(page, size) {
  try {
    const response = await api.get(
      `merchant/all/game-slots?page=${page}&size=${size}`,
      null
    );
    return response;
  } catch (error) {
    // console.error(error);
    throw new Error("Slots could not be loaded");
  }
}

export async function getWinningNumbers(gameSlotId) {
  try {
    const response = await api.get(
      `merchant/lottery-winning-numbers/${gameSlotId}`
    );
    return response.data;
  } catch (error) {
    // console.error(error);
    throw new Error("Slots could not be loaded");
  }
}

export async function updateGameSlot(gameSlotId, payload) {
  try {
    const response = await axios.patch(
      `merchant/game-slot/update/${gameSlotId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error(`Game Slot with ID ${gameSlotId} could not be updated`);
  }
}

export async function getGameSlotDetailsId(gameSlotId) {
  try {
    const response = await api.get(`merchant/game-slot-details/${gameSlotId}`);
    return response?.data ?? response;
  } catch (error) {
    console.error("API Fetch Error:", error);
    return null;
  }
}
export async function getWinnersByGameSlotId(gameSlotId, page, size, search) {
  try {
    const params = new URLSearchParams({ page, size });

    if (search.trim()) {
      params.append("search", search);
    }

    const response = await api.get(
      `merchant/winners/${gameSlotId}?${params.toString()}`
    );

    return response.data;
  } catch (error) {
    console.error("API Fetch Error:", error);
    return [];
  }
}

export async function createSlot(payload) {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.post("merchant/game-slot/create", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Game Slot could not be created");
  }
}

export async function deleteSlot(id) {
  try {
    const response = await api.delete(`merchant/delete/game-slot/${id}`, null);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Slot could not be deleted");
  }
}

export async function CreateWinners(data, gameSlotId) {
  try {
    const response = await api.create(`merchant/winners/${gameSlotId}`, data);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error("Winners could not be created");
  }
}

export async function runLotteryDrawNow(gameSlotId) {
  try {
    const response = await api.create(`merchant/lottery-draw/${gameSlotId}/run`, {});
    return response?.data ?? response;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to trigger lottery draw");
  }
}
